var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 8.33398C3.25 8.33398 2.5 9.08398 2.5 10.0007C2.5 10.9173 3.25 11.6673 4.16667 11.6673C5.08333 11.6673 5.83333 10.9173 5.83333 10.0007C5.83333 9.08398 5.08333 8.33398 4.16667 8.33398Z",
    fill: "#565A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8385 8.33398C14.9219 8.33398 14.1719 9.08398 14.1719 10.0007C14.1719 10.9173 14.9219 11.6673 15.8385 11.6673C16.7552 11.6673 17.5052 10.9173 17.5052 10.0007C17.5052 9.08398 16.7552 8.33398 15.8385 8.33398Z",
    fill: "#565A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99479 8.33398C9.07813 8.33398 8.32812 9.08398 8.32812 10.0007C8.32812 10.9173 9.07813 11.6673 9.99479 11.6673C10.9115 11.6673 11.6615 10.9173 11.6615 10.0007C11.6615 9.08398 10.9115 8.33398 9.99479 8.33398Z",
    fill: "#565A6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsHorizontal);
export default __webpack_public_path__ + "static/media/dots-horizontal.1beca4f681061fb069fdd952e199f814.svg";
export { ForwardRef as ReactComponent };